import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    padding: 15,
    marginBottom: 30
  },
  header: {
    marginBottom: 20
  },
  inputs: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  marginBottomInputs: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 30
  },
  inputsContainer: {
    display: 'grid',
    gridTemplateColumns: ' 2fr 1fr',
    gap: '40px',
    width: '100%',
    alignItems: 'flex-start',
    [theme.breakpoints.up(1440)]: {
      gridTemplateColumns: '5fr 2fr',
      gap: '50px'
    },
    [theme.breakpoints.up(2200)]: {
      gridTemplateColumns: '5fr 3fr',
      gap: '40px'
    },
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  inputProviderName: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    marginBottom: '16px',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '0px',
      gap: '0px'
    }
  },
  inputProviderPull: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '0px',
      gap: '0px'
    }
  },
  inputSection: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  switchAndButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '20px',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    },
    [theme.breakpoints.down(400)]: {
      alignItems: 'flex-end',
      flexDirection: 'column'
    }
  },
  switchForProviderSubmit: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'center'
  },
  tableSortLabel: {
    color: theme.palette.grey[800]
  },
  mainDropDownIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down(400)]: {
      marginTop: '25px'
    }
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  fontFamilyInput: {
    fontFamily: 'IranSans'
  }
}))
export default useStyles
